import React, { useState, FC, FocusEvent, ChangeEvent, useRef } from 'react';
import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms';
import { DateInputViewModel } from '@sitecore-jss/sitecore-jss-forms';
import Icon from '../../../@shared/icon';
import { iconSize } from '../../../../constants/icon.constants';
import useFirstUserAction from '../../hooks/useFirstUserActionState';
import CustomTextLabel from '../@shared/customTextLabel';

const DateField: FC<ValueFieldProps<DateInputViewModel>> = (props) => {
  const { field, tracker } = props;
  const [hasFocus, setHasFocus] = useState(false);
  const [value, setValue] = useState(props.value);
  const inputRef = useRef<any>(null);
  const model = field?.model;
  const hasValueOrFocus = hasFocus || value !== '';
  const id = field.valueField.id;
  const name = field.valueField.name;
  const label = field?.model?.title;
  const hasAnyError = !!props.errors?.length;
  const FieldValidationErrors = props.fieldValidationErrorsComponent;
  const maxDate = model?.max?.split('T')[0];
  const minDate = model?.min?.split('T')[0];
  const errorColor = hasAnyError ? 'error' : undefined;
  const triggerFirstInteractionGTMEvent = useFirstUserAction();

  const onClick = (): void => {
    inputRef?.current?.showPicker();
    inputRef?.current?.focus();
  };

  const onFocus = (e: FocusEvent<HTMLInputElement>): void => {
    tracker.onFocusField(field, e?.target?.value);
    setHasFocus(true);
  };

  const onBlur = (e: FocusEvent<HTMLInputElement>): void => {
    tracker.onBlurField(field, e?.target?.value);
    setHasFocus(false);
  };

  const onChange = (e: ChangeEvent<HTMLInputElement>): void => {
    setValue(e?.target?.value);
    props.onChange(field?.valueField?.name, e?.target?.value, props?.isValid, []);
    setHasFocus(false);
    triggerFirstInteractionGTMEvent();
  };

  return (
    <div
      className={`sitecore-jss-form__control sitecore-jss-form__control--text-box ${
        hasAnyError ? 'sitecore-jss-form__control--has-error' : ''
      }`}
      onClick={onClick}
    >
      <div
        className={`
         sitecore-jss-form__control__date-field
         ${hasFocus ? 'sitecore-jss-form__control--has-focus' : ''}
       `}
      >
        <Icon iconName={'time-calendar'} size={iconSize.dsk} color={errorColor} extraClassName="sitecore-jss-form__date-icon" />
        <div className={'sitecore-jss-form__field-container'}>
          <label
            htmlFor={id}
            className={`sitecore-jss-form__label sitecore-jss-form__label--date ${
              hasValueOrFocus ? 'sitecore-jss-form__label--has-focus' : ''
            }`}
          >
            <CustomTextLabel label={label} />
          </label>
          <input
            id={id}
            name={name}
            ref={inputRef}
            className={`sitecore-jss-form__field
           sitecore-jss-form__field--date
           ${hasFocus ? 'sitecore-jss-form__field--has-focus' : ''}
           ${props.value ? 'sitecore-jss-form__field-value' : ''}`}
            type={'date'}
            onFocus={onFocus}
            onBlur={onBlur}
            onChange={onChange}
            value={props?.value?.split('T')[0]}
            min={minDate}
            max={maxDate}
            form="novalidatedform"
          />
        </div>
      </div>

      {FieldValidationErrors && <FieldValidationErrors {...props} />}
    </div>
  );
};

export default DateField;
